import { store } from "../store.js";
import { parsers } from "./parsers.js";

class SnippetsParser {
  constructor() {
    parsers.addType("config:snippets", this._applySnippets.bind(this));
  }

  _applySnippets(config) {
    for (const snippet of config.snippets) {
      store.set(`snippets.${snippet.snippetUid}`, snippet);
    }
  }
}

const snippetsParser = new SnippetsParser();
export { SnippetsParser, snippetsParser };
